module.exports = __webpack_public_path__ + "img/e0e80b3.jpg";